import { IUserDTO } from '@/dtos';
import { get, post } from '@/services/apiWrapper';
export const getMySelfAPI = async (): Promise<IUserDTO> => {
  const user = get<IUserDTO>('/users/myself');
  return user;
};

export const updateMyProfileAPI = async (user: IUserDTO): Promise<IUserDTO> => {
  const result = post<IUserDTO>('/users/myself', user);
  return result;
};

export const resetMyPasswordAPI = async (password: string): Promise<boolean> => {
  const body = { password: password };
  const result = post<boolean>('/users/password', body);
  return result;
};

export const checkEmailAddressAPI = async (email: string, userId?: string): Promise<boolean> => {
  const body = { email: email, userId: userId };
  const result = post<boolean>('/users/validateEmail', body);
  return result;
};

export const getForgotPasswordValidationCodeAPI = async (email: string): Promise<boolean> => {
  const code = await post<boolean>(`/forgot-password-code?email=${email}`);
  return code;
};

export const validateForgotPasswordCodeAPI = async (
  code: string,
  email: string,
): Promise<boolean> => {
  const validated = await post<boolean>(`/forgot-password-code/confirm`, {
    code: code,
    email: email,
  });
  return validated;
};

export const resetForgotPasswordAPI = async (
  code: string,
  email: string,
  password: string,
): Promise<boolean> => {
  const validated = await post<boolean>(`/forgot-password-reset`, {
    code: code,
    email: email,
    password: password,
  });
  return validated;
};

export async function resendValidationEmailAPI(email: string): Promise<boolean> {
  const body = { email_address: email };
  const result = post<boolean>('resend-email-validation', body);
  return result;
}
